import { render } from "./FixPriceLotComponent.vue?vue&type=template&id=2c82069e"
import script from "./FixPriceLotComponent.vue?vue&type=script&lang=js"
export * from "./FixPriceLotComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/auctions/FixPriceLotComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c82069e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c82069e', __exports__)) {
    console.log('reload')
    api.reload('2c82069e', __exports__)
  }
  
  module.hot.accept("./FixPriceLotComponent.vue?vue&type=template&id=2c82069e", () => {
    console.log('re-render')
    api.rerender('2c82069e', render)
  })

}


export default __exports__